import moment from 'moment'
import { CvsAvatar } from '@components'

export function displayTypeAs(type, value) {
  let transformedValue = value
  switch (type) {
    case 'avatar':
      transformedValue = (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          <CvsAvatar user={value} />
          <span>{value.name}</span>
        </span>
      )
      break
    case 'number':
      transformedValue = Intl.NumberFormat().format(value)
      break
    case 'date':
      transformedValue = moment(value).format('MM/DD/YY')
      break
    case 'boolean':
      transformedValue = value ? 'true' : 'false'
      break
    case 'list':
      transformedValue = value.map(f => f.name).join(', ')
      break
    case 'target':
      transformedValue = value
        .map(targetField => `${targetField.target.name} > ${targetField.name}`)
        .join(', ')
      break
    default:
      transformedValue = value
      break
  }
  return transformedValue
}
